function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }
  return _typeof(obj);
}
function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys.forEach(function (key) {
      _defineProperty(target, key, source[key]);
    });
  }
  return target;
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}
function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}
function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }
  return _assertThisInitialized(self);
}
function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return _setPrototypeOf(o, p);
}
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
import React, { PureComponent } from "react";
import PropTypes from "prop-types";
import TooltipContent from "./TooltipContent";
import Transition from "react-transition-group/Transition";
export var TooltipPortal = /*#__PURE__*/
function (_PureComponent) {
  _inherits(TooltipPortal, _PureComponent);
  function TooltipPortal() {
    var _getPrototypeOf2;
    var _this;
    _classCallCheck(this, TooltipPortal);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(TooltipPortal)).call.apply(_getPrototypeOf2, [this].concat(args)));
    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "state", {
      hovering: false,
      tipPosition: {
        all: {
          x: 0,
          y: 0
        }
      }
    });
    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "mouseEnter", function (event) {
      var rect = event.target.getBoundingClientRect();
      var x = (rect.left + rect.right) / 2;
      var y = (rect.top + rect.bottom) / 2;
      _this.setState({
        tipPosition: _objectSpread({
          center: {
            x: x,
            y: y
          },
          top: {
            x: x,
            y: rect.top
          },
          bottom: {
            x: x,
            y: rect.bottom
          }
        }, _this.props.center ? {} : {
          left: {
            x: rect.right - _this.props.arrowOffset,
            y: y
          },
          right: {
            x: rect.left + _this.props.arrowOffset,
            y: y
          }
        }),
        hovering: true
      });
    });
    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "mouseMove", function (event) {
      _this.setState({
        tipPosition: {
          all: {
            x: event.clientX,
            y: event.clientY
          }
        },
        hovering: true
      });
    });
    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "mouseLeft", function () {
      _this.setState({
        hovering: false
      });
    });
    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "mergeCallbacks", function (childCallback, tooltipCallback) {
      if (childCallback) {
        return function (event) {
          childCallback(event);
          tooltipCallback(event);
        };
      }
      return tooltipCallback;
    });
    return _this;
  }
  _createClass(TooltipPortal, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.props.tooltipRootDOM) {
        this.tooltipRootDOM = this.props.tooltipRootDOM;
        return;
      } else if (!document.getElementById("tooltip-root")) {
        var tooltipRootDOM = document.createElement("div");
        tooltipRootDOM.setAttribute("id", "tooltip-root");
        document.getElementsByTagName("body")[0].appendChild(tooltipRootDOM);
      }
      this.tooltipRootDOM = document.getElementById("tooltip-root");
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props = this.props,
        content = _this$props.content,
        children = _this$props.children,
        transitionDuration = _this$props.transitionDuration,
        followMouse = _this$props.followMouse;
      var _this$state = this.state,
        tipPosition = _this$state.tipPosition,
        hovering = _this$state.hovering;
      return [React.isValidElement(children) && children.type.toString() !== React.Fragment.toString() ? React.cloneElement(children, _objectSpread({
        key: "child"
      }, followMouse ? {
        onMouseMove: this.mergeCallbacks(children.props.onMouseMove, this.mouseMove)
      } : {
        onMouseEnter: this.mergeCallbacks(children.props.onMouseEnter, this.mouseEnter)
      }, {
        onMouseLeave: this.mergeCallbacks(children.props.onMouseLeave, this.mouseLeft)
      })) : React.createElement("span", {
        key: "child",
        onMouseEnter: followMouse ? undefined : this.mouseEnter,
        onMouseMove: followMouse ? this.mouseMove : undefined,
        onMouseLeave: this.mouseLeft
      }, children), this.tooltipRootDOM && content ? React.createElement(Transition, {
        key: "tooltip-content",
        in: hovering,
        timeout: transitionDuration,
        appear: true,
        unmountOnExit: true
      }, function (state) {
        return React.createElement(TooltipContent, _extends({}, _this2.props, {
          tipPosition: tipPosition,
          tooltipRootDOM: _this2.tooltipRootDOM,
          transition: state !== "entered"
        }), content);
      }) : null];
    }
  }]);
  return TooltipPortal;
}(PureComponent);
_defineProperty(TooltipPortal, "propTypes", {
  // HTML root element where you want the tooltip to be rendered
  tooltipRootDOM: PropTypes.instanceOf(Element),
  // The content to be displayed by the tooltip
  content: PropTypes.node,
  // The element to be tooltiped
  children: PropTypes.node,
  transitionDuration: PropTypes.number,
  tipOffset: PropTypes.number,
  arrowOffset: PropTypes.number,
  arrowSize: PropTypes.number,
  followMouse: PropTypes.bool,
  center: PropTypes.bool,
  forcedHorizontal: PropTypes.oneOf(["left", "right"]),
  forcedVertical: PropTypes.oneOf(["top", "bottom"])
});
_defineProperty(TooltipPortal, "defaultProps", {
  transitionDuration: 300,
  followMouse: false,
  center: false,
  tipOffset: 0,
  arrowOffset: 8,
  arrowSize: 7
});
export default TooltipPortal;